import React from 'react';
import PropTypes from 'prop-types';
import {isArray, map, startsWith, uniqBy} from 'lodash';

import TagList from './tag-list';

import searchHoc from '../components-app/search-wrapper';

// Styles
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

const servicesDataKey = 'aliasesList';

const AliasesList = ({handleUpdateAlias, id, searchData, values}) => (
    <TagList
        filter={true}
        filterBy="label,value"
        filterPlaceholder="Ams Genre"
        handleUpdateTag={handleUpdateAlias}
        id={id}
        options={
            isArray(searchData.aliases)
                ? map(uniqBy(searchData.aliases, 'aliasName'), alias => ({
                      label: startsWith(alias.aliasName, ' ') ? `'${alias.aliasName}'` : alias.aliasName,
                      value: alias.aliasName,
                  }))
                : []
        }
        values={values}
    />
);

AliasesList.propTypes = {
    handleUpdateAlias: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    searchData: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    values: PropTypes.array.isRequired,
};

export default searchHoc(AliasesList, servicesDataKey);
